<!--
 * @Author: zhouwei
 * @Date: 2020-04-12 20:28:52
 * @LastEditors: zhouwei
 * @LastEditTime: 2020-04-12 14:46:12
 * @Description: 任务分析
 -->
<template>
  <div class="statistical-data">
    <create-header
      :need-back-txt="false"
      title="课程分析"
    >
      <dept-member-select-biz
        v-model="dmList"
        class="dm-select"
        width="320"
        placeholder="请选择部门或成员"
        @change-ids="changeIds"
      />
    </create-header>
    <detail
      :id="id"
      ref="detail"
      :type="1"
    />
  </div>
</template>
<script>
import createHeader from '@components/create-header'
import deptMemberSelectBiz from '@components/dept-member-select-biz'
import detail from './detail'
import { MBASVCAPIS, ACCOUNTAPIS } from '@api'
export default {
  components: {
    createHeader,
    deptMemberSelectBiz,
    detail
  },
  data () {
    return {
      title: '任务总览',
      dmList: {
        dept: [],
        member: []
      },
      options: [],
      id: ''
    }
  },
  // watch: {
  //   title (val) {
  //     if (val === '任务总览') {
  //       this.courseExamValue = this.initCourseExamValue
  //     }
  //   }
  // },
  created () {
    this.id = this.$route.query.id
    window.departmentIds = []
    window.userIds = []
    this.missionDetailGet()
  },
  beforeDestroy () {
    window.departmentIds = []
    window.userIds = []
  },
  methods: {
    getType (id) {
      let type = 1
      let len = this.options.length
      for (let i = 0; i < len; i++) {
        if (id === this.options[i]._id) {
          type = this.options[i].type
          break
        }
      }
      return type
    },
    change () {
      // if (this.$refs.detail) {
      //   this.$refs.detail.init(this.initCourseExamValue)
      // }
    },
    // 获取内容详情
    async missionDetailGet () {
      const { success, data } = await MBASVCAPIS.MissionApi.missionCourseExamListGet({
        _id: this.$route.query.id
      })
      if (success) {
        this.options = data.data
        if (data.data.length > 0) {
          this.courseExamValue = data.data[0]._id
          this.initCourseExamValue = data.data[0]._id
        }
      }
    },
    changeIds (data) {
      if (data.deptId.length === 1 && data.memberId.length === 0 && data.deptId[0] === 'NA') {
        window.departmentIds = []
        window.userIds = []
      } else {
        window.departmentIds = data.deptId
        window.userIds = data.memberId
      }

      if (this.$refs.overview) {
        this.$refs.overview.update({
          departmentIds: data.deptId,
          userIds: data.memberId
        })
      }
      if (this.$refs.detail) {
        this.$refs.detail.update({
          departmentIds: data.deptId,
          userIds: data.memberId
        })
      }
    }
  }
}
</script>
<style lang="scss" scoped>
  .statistical-data {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;

    /deep/ .dm-select {
      margin: 14px 20px;
    }

    .statistical-data-t {
      height: 32px;
      display: flex;
      justify-content: space-between;
      margin: 20px;
    }
  }
</style>
